import React from "react";
import Modal from "../../common/Modal/Modal";
import { useNavigate } from "react-router-dom";

export default function ExternalFormSubmittedModal({
  isOpen,
  isSuccess,
  isError,
  errorMessage,
  isMerged,
  onClose,
}) {
  const navigate = useNavigate();

  const handleCloseModal = () => {
    if (isSuccess) {
      navigate("/datarequests");
    }
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleCloseModal}
      title={isError ? "Error Submitting Report" : "Submit Snapshot"}
      showCustomContent={true}
      customContent={
        isSuccess ? (
          <>
            <div className="modal-success-container">
              <div className="icon-container">
                <i className="fas fa-check" />
              </div>
              <p className="success-message">
              {isMerged
                  ? "You have successfully merged your form!"
                  : "You have successfully submitted your form!"}
              </p>
            </div>
            <div className="button-close-container">
              <button className="button-close" onClick={handleCloseModal}>
                Okay
              </button>
            </div>
          </>
        ) : isError ? (
          <>
            <div className="error-message">{errorMessage}</div>
            <div>
              <div className="button-close-container">
                <button className="button-close" onClick={handleCloseModal}>
                  Close
                </button>
              </div>
            </div>
          </>
        ) : null
      }
    />
  );
}
